import { Component, OnInit } from '@angular/core';
import { RestResponse, SearchObject } from '../../services/Rest';
import { BaseComponent } from '../base/base.component';
import { forkJoin, from, Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';

import {Order, Payment, User, Sat_Factura} from '../../models/RestModels';
import {Store} from '../../models/RestModels';
import {Price_Type, Currency} from '../../models/RestModels';
import { OrderInfo, OrderItemInfo, PaymentInfo, ReturnsInfo } from '../../models/models';
import { mergeMap} from 'rxjs/operators';
import { Utils} from 'src/app/classes/Utils';
import { ExcelUtils } from 'src/app/classes/ExcelUtils';
import { GetEmpty } from 'src/app/classes/Empties';

interface CustomOrderDetails extends OrderInfo
{
	payments:Array<PaymentInfo>;
}

export interface CustomOrderInfo extends OrderInfo
{
	article_discount:number;
	price_name:string;
	selected:boolean;
	pdf_url:string;
}

interface COrder extends Order
{
	total_final:number;
	paid_to_user_id:number;
	to_prepare: '' | '1';
	payment_currency_id:string;
}

@Component
({
	selector: 'app-list-order',
	templateUrl: './list-order.component.html',
	styleUrls: ['./list-order.component.css']
})

export class ListOrderComponent extends BaseComponent implements OnInit
{
	file:File | null= null;
	show_import:boolean = false;
	order_search:SearchObject<COrder> = this.getEmptySearch();
	order_info_list:CustomOrderInfo[] = [];
	User:User | null = null;

	store_list:Store[] = [];
	price_type_list:Price_Type[] = [];
	currency_list:Currency[] = [];
	store_dictionary:Record<number,Store> = {};
	price_type_dic:Record<number,Price_Type> = {};
	order_total:number = 0;
	total_descuentos:number = 0;
	show_asign_delivery_user:boolean = false;
	selected_order_info:OrderInfo | null = null;
	show_returns:boolean = false;
	cashier_user_list:User[] = [];
	show_create_shipping:boolean = false;

	fecha_inicial:string = '';
	fecha_final:string = '';
	shipping_guide: any;
	shipping_company: any;
	shipping_date: any;
	mark_as_sent:boolean = false;
	show_advanced_search:boolean = false;
	show_offline_options:boolean = false;
	show_cancel_order: boolean = false;
	cancellation_reason:string = '';
	user: User = null;
	agent_user:User | null = null;
	client:User | null = null;

	// Export modal properties
	show_export_modal: boolean = false;
	export_loading_current: number = 0;
	export_loading_total: number = 0;
	export_progress: number = 0;
	export_message: string = '';

	ngOnInit()
	{
		this.path = '/list-order';

		this.subs.sink = this.rest.updates
		.pipe
		(
			filter((message)=>
			{

				if( !this.rest.current_permission.view_commandas )
					return false;

				//Actualizar si se esta en el elemento que cambio esta en la pagina actual
				//ó si es la pagina zero

				if( message.id )
				{
					//Si la orden esta en la lista actual
					if( this.order_info_list.some(order_info=>message.id == order_info.order.id) )
						return true;
				}
				//Actualizar solo si se esta en la pagina 0
				return message.type == 'order' && this.order_search.page == 0
			}),
			mergeMap((message)=>
			{
				return this.rest.order.get( message.id );
			})
		)
		.subscribe((order)=>
		{
			console.log('LLego order',order);

			if( order.store_id == this.rest.current_user.store_id )
			{
				this.search( this.order_search );
			}
		});

		//this.subs.sink = this.

		this.subs.sink = this.route.queryParamMap.pipe
		(
			mergeMap((query_params)=>
			{
				let fields = [
					"address","amount_paid","cashier_user_id","city","client_name","client_user_id",
					"created","created_by_user_id","delivery_status","facturacion_code","facturado",
					"id","name","paid_status","paid_to_user_id","price_type_id","sat_factura_id",
					"sat_razon_social","shipping_address_id","state","status","store_consecutive",
					"store_id","subtotal","suburb","tax","to_prepare","total", "total_final", "type","updated",
					"updated_by_user_id","zipcode","payment_currency_id"
				];

				let extra_keys:Array<string> =
				[
					'transaction_type','publico_general','advanced_search','total_final',
					'with_discounts','agent_user_id','start_timestamp','end_timestamp'
				];

				let order_search:SearchObject<COrder> = this.getSearch( query_params, fields, extra_keys );

				this.user = null;
				this.setTitle('Ordenes');
				this.is_loading = true;
				order_search.limit = this.page_size;
				this.current_page = this.order_search.page;

				if(!order_search?.eq?.client_user_id && !this.rest.current_permission.list_orders )
				{
					order_search.limit = 1;
					order_search.page = 0;
					this.current_page = 0;
				}

				if( order_search.sort_order.length == 0 )
				{
					order_search.sort_order = ['id_DESC'];
				}

				if( order_search.eq.to_prepare )
				{
					order_search.search_extra['for_listing'] = null;
				}
				else
				{
					order_search.search_extra['for_listing'] = 1;
				}

				this.show_advanced_search = !!order_search.search_extra.advanced_search;

				if( this.rest.is_offline )
				{
					return from( this.rest.getOfflineOrders().then((response)=>{
						return Promise.resolve
						({
							orders:{
								data: response,
								total: response.length
							},
							user: null,
							agent: null
						});
					})) as Observable<{orders:RestResponse<OrderInfo>,user:User|null,agent:User|null}>;
				}

				if( !(order_search.eq.price_type_id ) )
					order_search.eq.price_type_id = null;

				if( order_search.search_extra.publico_general )
				{
					order_search.is_null = ['client_user_id']
					//order_search.eq.price_type_id = 1;
				}
				else
				{
					order_search.is_null = [];
				}

				if( !this.rest.current_permission.global_pos )
				{
					order_search.eq.store_id = this.rest.current_user.store_id;
				}

				let add_fecha =!(	query_params.has('ge.status')	||
									query_params.has('eq.client_user_id')	||
									query_params.has('client_name')	||
									query_params.has('search_extra.start_timestamp')	||
									query_params.has('eq.store_consecutive')
								);

				if( add_fecha )
				{
					let date = new Date();
					date.setHours(0);
					date.setMinutes(0);
					date.setSeconds(0);
					order_search.search_extra.start_timestamp = date;
				}

				if( order_search.search_extra.start_timestamp )
				{
					this.fecha_inicial = Utils.getLocalMysqlStringFromDate( order_search.search_extra.start_timestamp	as Date).replace(' ','T');
				}
				else
				{
					this.fecha_inicial = '';
				}

				if( order_search.search_extra.end_timestamp)
				{
					this.fecha_final = Utils.getLocalMysqlStringFromDate( order_search.search_extra.end_timestamp as Date).replace(' ','T');
				}
				else
				{
					this.fecha_final = '';
				}

				//XXX HACK
				//order_search.le.created = null;
				//order_search.ge.created = null;

				order_search.search_extra['hades'] = this.rest.has_ares ? 1: null;

				this.order_search = order_search;

				return forkJoin
				({
					orders: this.rest.order_info.search( this.order_search ),
					user: this.order_search.eq.client_user_id
						? this.rest.user.get( this.order_search.eq.client_user_id )
						: of( null ),
					agent: this.order_search.search_extra.agent_user_id
						? this.rest.user.get( this.order_search.search_extra.agent_user_id )
						: of( null )
				})
			}),
			mergeMap((response)=>
			{
				this.client = response.user;

				let tmp_total = response.orders.data.reduce((p,c)=>p+c.order.total,0);

				let store_obs = this.store_list.length > 0
					? of({data:this.store_list, total: this.store_list.length})
					: this.rest.store.search({limit:999999, eq:{sales_enabled:1}, sort_order:['name_ASC']});


				let cashier_user_obs = this.cashier_user_list.length > 0 || this.rest.is_offline
					? of({ data:this.cashier_user_list, total: this.cashier_user_list.length } as RestResponse<User>)
					: this.rest.user.search
					({
						limit:9999, eq:{type:'USER'},
						sort_order:['name_ASC'],
						search_extra:{ 'user_permission.pos': 1 }
					});

				let currency_obs = this.currency_list.length > 0
					? of({data:this.currency_list, total: this.currency_list.length})
					: this.rest.currency.search({limit:99999, sort_order:['name_ASC']});

				return forkJoin
				({
					order : of( response.orders ),
					store : store_obs,
					price_type : this.rest.getPriceTypes(true),
					users: cashier_user_obs,
					currencies: currency_obs,
					order_total: this.rest.is_offline || !this.rest.current_permission.reports ? of({total:tmp_total,data:[]}) : this.rest.getOrderTotal(this.order_search),
					user: of( response.user ),
					agent: of( response.agent )
				})
			})
		)
		.subscribe
		({
			next:(responses)=>
			{
				this.is_loading = false;
				this.user	= responses.user;
				responses.store.data.forEach(store=>this.store_dictionary[store.id]=store);
				responses.price_type.data.forEach(price_type=>this.price_type_dic[ price_type.id ] = price_type);
				this.store_list	= responses.store.data;
				this.currency_list = responses.currencies.data;

				this.cashier_user_list	= responses.users.data.map((user:User)=>
				{
					if( user.username?.toLowerCase()?.localeCompare( user?.name?.toLowerCase() ) != 0 )
					{
						user.name = user.name+' ('+user.username+')';
					}
					return user;
				});

				this.price_type_list	= responses.price_type.data;
				this.order_total		= responses.order_total.total;
				this.order_info_list	= responses.order.data.map(oi=> this.getCustomOrderInfo(oi));
				this.total_descuentos	= this.order_info_list.reduce((prev, oi) => prev + oi.order.discount + oi.article_discount, 0);
				this.agent_user	= responses.agent;

				this.setPages( this.order_search.page, responses.order.total );
			},
			error:(error)=>
			{
				this.showError(error)
			}
		});
	}

	canOpenOrderInPos(order:Order)
	{
		return !!this.rest.current_permission.list_orders
			&& !!order.id
			&& order.status != 'CANCELLED'
			&& order.paid_status == 'PENDING';
	}

	canOpenOrderView(order:Order)
	{
		return !!order.id && (!this.rest.current_permission.list_orders || order.status == 'CANCELLED' || order.paid_status != 'PENDING');
	}

	confirmReadyToPickup(order_info:OrderInfo)
	{
		this.subs.sink = this.confirmation.showConfirmAlert(order_info
			,'Marcar Como Listo para recoger'
			,'Esta seguro de querer marcar la orden como preparada y lista para recoger'
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.subs.sink = this.rest
				.updateOrderDeliveryStatus( order_info.order.id, 'READY_TO_PICKUP')
				.subscribe(()=>
				{
					order_info.order.delivery_status = 'READY_TO_PICKUP';
					this.rest.sendNotification('order', order_info.order.id );
					this.showSuccess('La orden se marco como lista para recoger');
				},(error)=>this.showError(error));
			}
		});
	}
	confirmSend(order_info:OrderInfo)
	{
		this.subs.sink = this.confirmation.showConfirmAlert
		(
			order_info,
			'Marcar Como Enviado',
			'Esta seguro de querer marcar la orden como enviada'
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.subs.sink = this.rest
				.updateOrderDeliveryStatus(order_info.order.id, 'SENT')
				.subscribe(()=>
				{
					order_info.order.delivery_status = 'SENT';
					this.showSuccess('La orden se marco como enviada');
					this.rest.sendNotification('order', order_info.order.id);
				},(error)=>this.showError(error));
			}
		});
	}
	showSelectDeliveryUser(selected_order_info:OrderInfo)
	{
		this.selected_order_info = selected_order_info;
		this.show_asign_delivery_user = true;
	}
	onDeliveryUserSelected(user:User | null)
	{
		this.show_asign_delivery_user = false;
		if( user != null )
		{
			this.selected_order_info.order.delivery_user_id = user.id;
		}
	}

	confirmDelivered(order_info:OrderInfo)
	{
		this.selected_order_info = order_info;
		this.subs.sink = this.confirmation.showConfirmAlert
		(
			order_info,
			'Marcar Como Entregado',
			'Esta seguro de querer marcar la orden como Entregada'
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.is_loading = true;
				this.subs.sink = this.rest
				.updateOrderDeliveryStatus( this.selected_order_info.order.id, 'DELIVERED' )
				.subscribe(()=>
				{
					this.is_loading = false;
					this.rest.sendNotification('order', order_info.order.id);
					this.selected_order_info.order.delivery_status = 'DELIVERED';
					this.rest.sendNotification('order', order_info.order.id);
				},(error)=>{this.showError(error)});
			}
		});
	}
	togglePublicoGeneral(evt:Event)
	{
		let mouse_event:MouseEvent = evt as MouseEvent;
		let checkbox:HTMLInputElement = evt.target as HTMLInputElement;
		//checkbox.checked = !checkbox.checked;

		let eq = this.order_search.eq as any;
		if( !checkbox.checked )
		{
			eq.price_type_id = null;//Solo personas avanzadas no lo intenteis en casa
		}
		else
		{
			//eq.price_type_id = 1;
		}

		this.order_search.search_extra.publico_general = checkbox.checked ? '1': null;
	}

	search(search_object:SearchObject<COrder>)
	{
		if( !this.show_advanced_search )
		{
			super.search({
				eq:{ store_id : search_object.eq.store_id, client_user_id:search_object.eq.client_user_id || null },
				ge:{ created: search_object.ge.created },
				le:{ created: search_object.le.created },
				search_extra:{
					agent_user_id: search_object.search_extra.agent_user_id || null,
					total_final: search_object.search_extra.total_final,
					advanced_search: (this.show_advanced_search ? '1' : ''),
					start_timestamp: search_object.search_extra.start_timestamp,
					end_timestamp: search_object.search_extra.end_timestamp
				}
			});
			return;
		};

		search_object.csv.status = [];
		//search_object.eq.client_user_id = null;
		if( this.show_advanced_search )
			search_object.search_extra.advanced_search = 1;

		console.log('not advanced_search');
		super.search( search_object )
	}

	showOrderReturnModal(order_info:OrderInfo)
	{
		this.selected_order_info = order_info;
		this.show_returns = true;
	}

	onOrderReturned(returns_info:ReturnsInfo)
	{
		this.show_returns = false;
		console.log('returned', returns_info);
	}
	confirmCancel(order_info:OrderInfo)
	{
		this.show_cancel_order = true;
		this.selected_order_info = order_info;
		//this.subs.sink = this.confirmation
		//.showConfirmAlert(order_info,"Cancelar Orden",'Estas seguro de querer cancelar la orden "'+order_info.order.id+'"')
		//.subscribe((response)=>
		//{
		//	if( response.accepted )
		//	{
		//		this.is_loading = true;
		//		this.subs.sink = this.rest
		//			.cancelOrder( order_info.order.id )
		//			.subscribe
		//			(
		//				()=>
		//				{
		//					this.is_loading = false;
		//					order_info.order.status = 'CANCELLED';
		//					this.showSuccess('La orden se cancelo exitosamente');
		//				},
		//				(error)=>{ this.showError(error) }
		//			);
		//	}
		//},(error:any)=>
		//{
		//	console.log('Ocurrio un error en el systema',error);
		//});
	}

	exportOrders(evt:Event)
	{
		let search:SearchObject<Order> = {...this.order_search};
		search.limit = 100;

		let status_dict:Record<string,string> = {
			'PENDING':'Pendiente',
			'ACTIVE':'Activa',
			'CANCELLED':'Cancelada',
			'CLOSED':'Cerrada',
		}


		this.show_export_modal = true;
		this.export_message = 'Descargando...';
		this.export_progress = 0;

		let update_lambda = (counter: number, total: number) => {
			this.export_loading_current = counter + 1;
			this.export_loading_total = total;
			this.export_progress = ((counter + 1) / total) * 100;
		};

		this.subs.sink = this.rest.order_info
		.searchAllWithProgress(search, 100, false, update_lambda)
		.subscribe((response)=>
		{
			this.show_export_modal = false;

			let payment_method = {
				'01': 'Efectivo',
				'02': 'Cheque',
				'04': 'T. Credito',
				'05': 'Monedero Electrónico',
				'28': 'T. Debito',
				'03': 'Transferencia',
				'99': 'Credito',
			};

			let cdate = Utils.getLocalMysqlStringFromDate(new Date()).substring(0,10);

			let array = response.data.map((order_info:OrderInfo)=>{

				let s = order_info.order.sat_forma_pago in payment_method ? payment_method[ order_info.order.sat_forma_pago ] : 'Por Definir';
				return {
					'Id':	order_info.order.id,
					'Cliente':	order_info?.client?.name || order_info.order.client_name,
					'Total':	order_info.order.total,
					'Pagado':	order_info.order.amount_paid,
					'Sucursal':	order_info.store.name,
					'Folio':	order_info.order.store_consecutive,
					'Fecha':	Utils.getLocalMysqlStringFromDate(order_info.order?.system_activated ? order_info.order.system_activated : order_info.order.created ).substring(0,10),
					'Estatus':	status_dict[ order_info.order.status ],
					'Facturado':	order_info?.sat_factura ? 'Si' : 'No',
					'Pago': s
				}
			});
			ExcelUtils.array2xlsx(array,'orders-'+cdate+'.xlsx', ['Id','Cliente','Total','Pagado','Sucursal','Folio','Facturado','Fecha','Pago','Estatus']);
		},(error)=>{
			this.show_export_modal = false;
			this.showError(error);
		});
	}

	exportOrdersWithItems(evt:Event)
	{
		let search:SearchObject<Order> = {...this.order_search};
		search.limit = 100;

		let status_dict:Record<string,string> = {
			'PENDING':'Pendiente',
			'ACTIVE':'Activa',
			'CANCELLED':'Cancelada',
			'CLOSED':'Cerrada',
		}

		this.show_export_modal = true;
		this.export_message = 'Descargando...';
		this.export_progress = 0;

		let update_lambda = (counter: number, total: number) => {
			this.export_loading_current = counter + 1;
			this.export_loading_total = total;
			this.export_progress = ((counter + 1) / total) * 100;
		};

		this.subs.sink = this.rest.order_info
		.searchAllWithProgress(search, 100, false, update_lambda).pipe
		(
			mergeMap((all:RestResponse<OrderInfo>)=>
			{
				let order_ids = all.data.map(oi=>oi.order.id);
				let payment_observables:Observable<RestResponse<PaymentInfo>>[] = [];

				while( order_ids.length )
				{
					let ids = order_ids.splice(0,100);

					let	search:SearchObject<Payment>	=	this.getEmptySearch();
					search.search_extra	=	{order_id:ids.join(',')};
					search.limit	=	9999;
					payment_observables.push( this.rest.payment_info.search( search ) );
				}

				if( payment_observables.length == 0 )
				{
					return of
					({
						payments: [],
						orders: all
					});
				}

				return forkJoin
				({
					payments: forkJoin( payment_observables ),
					orders: of( all )
				})
			})
		)
		.subscribe((response)=>
		{
			let payment_maps = this.getPaymentByOrderIdMap( response.payments );
			let cdate = Utils.getLocalMysqlStringFromDate(new Date()).substring(0,10);
			let rows:Object[] = [];
			let a = '';

			let empty_obj = {
				'Id': a,
				'Cliente': a,
				'Total': a,
				'Pagado': a,
				'Sucursal': a,
				'Folio': a,
				'Fecha': a,
				'Estatus': a,
				'Facturado': a,
				'Método de Pago': a
			};

			for(let order_info of response.orders.data)
			{
				let id = order_info.order.id;
				let cliente = order_info?.client?.name || order_info.order.client_name;
				let total = order_info.order.total;
				let pagado = order_info.order.amount_paid;
				let sucursal = order_info.store.name;
				let folio = order_info.order.store_consecutive;
				let fecha = Utils.getLocalMysqlStringFromDate(order_info.order?.system_activated ? order_info.order.system_activated : order_info.order.created ).substring(0,10);
				let estatus = status_dict[ order_info.order.status ];
				let facturado = order_info?.sat_factura ? 'Si' : 'No';
				let payments = payment_maps.get( id );
				let metodo_pago = this.getPaymentMethodsString( payments, order_info );

				let order_obj = {
					'Id': id,
					'Cliente': cliente,
					'Total': total,
					'Pagado': pagado,
					'Sucursal': sucursal,
					'Folio': folio,
					'Fecha': fecha,
					'Estatus': estatus,
					'Facturado': facturado,
					'Método de Pago': metodo_pago
				};

				if( order_info.items && order_info.items.length > 0 )
				{
					let i = 0;
					for(let item_info of order_info.items)
					{
						let item_obj = {
							'Articulo': item_info.item?.name || '',
							'Categoria': item_info.category?.name || '',
							'Cantidad': item_info.order_item.qty,
							'Precio Unitario': item_info.order_item.unitary_price,
							'Subtotal Item': item_info.order_item.subtotal,
							'Impuesto Item': item_info.order_item.tax,
							'Total Item': item_info.order_item.total
						};

						if( i == 0 )
						{
							rows.push({...order_obj, ...item_obj});
							i++;
						}
						else
						{
							rows.push({...empty_obj, ...item_obj});
						}
					}
				}
				else
				{
					// Si no hay items, agregar solo la información de la orden
					let item_obj = {
						'Articulo': a,
						'Categoria': a,
						'Cantidad': a,
						'Precio Unitario': a,
						'Subtotal Item': a,
						'Impuesto Item': a,
						'Total Item': a
					};
					rows.push({...order_obj, ...item_obj});
				}
			}

			ExcelUtils.array2xlsx(
				rows,
				'orders-items-'+cdate+'.xlsx',
				['Id','Cliente','Total','Pagado','Sucursal','Folio','Fecha','Estatus','Facturado','Método de Pago','Articulo','Categoria','Cantidad','Precio Unitario','Subtotal Item','Impuesto Item','Total Item']
			);
			this.show_export_modal = false;
		},(error)=>{
			this.show_export_modal = false;
			this.showError(error);
		});
	}

	exportOrdersDetails(evt:Event)
	{
		let search:SearchObject<Order> = {...this.order_search};
		search.limit = 100;

		let status_dict:Record<string,string> = {
			'PENDING':'Pendiente',
			'ACTIVE':'Activa',
			'CANCELLED':'Cancelada',
			'CLOSED':'Cerrada',
		}

		this.show_export_modal = true;
		this.export_message = 'Descargando...';
		this.export_progress = 0;

		let update_lambda = (counter: number, total: number) => {
			this.export_loading_current = counter + 1;
			this.export_loading_total = total;
			this.export_progress = ((counter + 1) / total) * 100;
		};

		this.subs.sink = this.rest.order_info
		.searchAllWithProgress(search, 100, false, update_lambda).pipe
		(
			mergeMap((all:RestResponse<OrderInfo>)=>
			{
				let order_ids = all.data.map(oi=>oi.order.id);
				let payment_observables:Observable<RestResponse<PaymentInfo>>[] = [];

				while( order_ids.length )
				{
					let ids = order_ids.splice(0,100);

					let	search:SearchObject<Payment>	=	this.getEmptySearch();
					search.search_extra	=	{order_id:ids.join(',')};
					search.limit	=	9999;
					payment_observables.push( this.rest.payment_info.search( search ) );
				}

				if( payment_observables.length == 0 )
				{
					return of
					({
						payments: [],
						orders: all
					});
				}

				return forkJoin
				({
					payments: forkJoin( payment_observables ),
					orders: of( all )
				})
			})
		)
		.subscribe((response)=>
		{
			let payment_maps = this.getPaymentByOrderIdMap( response.payments );
			console.log( payment_maps );
			let cdate = Utils.getLocalMysqlStringFromDate(new Date()).substring(0,10);
			let rows:Object[] = [];
			let a = '';
			let empty_obj = {
				'Id': a,
				'Cliente':	a,
				'Cliente Id' : a,
				'Total':	a,
				'Descuento Orden': a,
				'Descuento Articulos': a,
				'Pagado':	a,
				'Sucursal':	a,
				'Creacion': a,
				'Activación': a,
				'Cerrada': a,
				'Estatus':	a,
				'Facturado': a
			}

			for(let order_info of response.orders.data )
			{
				let id	= order_info.order.id;
				let client	= order_info?.client?.name || order_info.order.client_name;
				let client_id = order_info?.client?.id || '';
				let total	=	order_info.order.total;
				let pagado	=	order_info.order.amount_paid;
				let sucursal	=	order_info.store.name;
				// let folio	=	order_info.order.store_consecutive;
				let fecha		=	Utils.getLocalMysqlStringFromDate(order_info.order.created);
				let activacion	= order_info.order.system_activated ? Utils.getLocalMysqlStringFromDate(order_info.order.system_activated) : '';
				let cerrada		= order_info.order.closed_timestamp ? Utils.getLocalMysqlStringFromDate( order_info.order.closed_timestamp ) : '';
				let estatus		=	status_dict[ order_info.order.status ];
				let facturado	=	order_info.sat_factura ? 'Si' : 'No';
				let payments	= payment_maps.get( id );

				let order_obj = {
					'Id': id,
					'Cliente':	client,
					'Cliente Id' : client_id,
					'Total':	total,
					'Descuento Orden': order_info.order.discount,
					'Descuento Articulos': this.getArticleDiscount( order_info.items, order_info.order.tax_percent ),
					'Pagado':	pagado,
					'Sucursal':	sucursal,
					'Creacion': fecha,
					'Activación': activacion,
					'Cerrada': cerrada,
					'Estatus':	status_dict[ order_info.order.status ],
					'Facturado':	order_info.sat_factura ? 'Si' : 'No'
				};

				let payment_objs = payments ? this.getPaymentObject( payments, order_info): [];

				console.log( payment_objs );

				let i = 0;

				for(let po of payment_objs )
				{
					if( i == 0 )
					{
						rows.push({...order_obj, ...po });
						i++;
					}
					else
					{
						rows.push({...empty_obj, ...po });
					}
				}
			}

			ExcelUtils.array2xlsx(rows,'orders-'+cdate+'.xlsx', ['Id','Cliente','Cliente Id','Total','Descuento Orden','Descuento Articulos','Pagado','Sucursal','Creacion','Activación','Cerrada','Estatus','Facturado','ID Pago','Total Ingreso','Cantidad Pago','Fecha Pago','Tipo de Cambio','Tipo Transaccion','Cantidad Saldada','Referencia Bancaria','Registro Pago UTC','Registro Pago Local']);
			this.show_export_modal = false;
		},(error)=>{
			this.show_export_modal = false;
			this.showError(error);
		});
	}

	getPaymentObject(pi_array:PaymentInfo[],order_info:OrderInfo):Object[]
	{
		console.log( pi_array );
		let rows = [];

		type FOO = string | number | null;

		for(let paymen_info of pi_array)
		{
			for(let bm of paymen_info.movements)
			{
				let bmo_array = bm.bank_movement_orders.filter(bmo=>bmo.order_id == order_info.order.id);

				let ingreso_currency:FOO	= bm.bank_movement.currency_id;
				let ingreso_amount:FOO		= bm.bank_movement.amount_received;
				let referencia_bancaria:FOO	= bm.bank_movement.reference;
				let tipo_transaccion		= this.getTransactionType( bm.bank_movement.transaction_type );


				for( let bmo of bmo_array)
				{
					rows.push
					({
						'ID Pago'			:	paymen_info.payment.id,
						'Total Ingreso'		:	ingreso_amount+' '+ingreso_currency,
						'Cantidad Pago'		:	bmo.currency_amount+' '+ingreso_currency,
						'Fecha Pago'		:	bm.bank_movement.paid_date || '',
						'Tipo de Cambio'	:	bmo.exchange_rate,
						'Tipo Transaccion'	:	tipo_transaccion,
						'Cantidad Saldada'	:	bmo.amount+' '+order_info.order.currency_id,
						'Referencia Bancaria':	referencia_bancaria,
						'Registro Pago UTC'	:	Utils.getUTCMysqlStringFromDate( bm.bank_movement.created ),
						'Registro Pago Local':	Utils.getLocalMysqlStringFromDate( bm.bank_movement.created ),
					})
				}
			}
		}

		if( rows.length == 0 )
		{
			let a = '';
			rows.push
			({
				'ID Pago'			:	a,
				'Total Ingreso'		:	a,
				'Cantidad Pago'		:	a,
				'Fecha Pago'		:	a,
				'Tipo de Cambio'	:	a,
				'Tipo Transaccion'	:	a,
				'Cantidad Saldada'	:	a,
				'Referencia Bancaria':	a,
				'Registro Pago UTC'	:	a,
				'Registro Pago Local':	a
			});
		}

		return rows;
	}

	getTransactionType(str:string):string
	{
		switch( str )
		{
			case 'CASH':	return 'Efectivo';
			case 'CREDIT_CARD':	return 'Tarjeta Crédito';
			case 'DEBIT_CARD':	return 'Tarjeta Débito';
			case 'CHECK':		return 'Cheque';
			case 'COUPON':		return 'Cupón';
			case 'TRANSFER':		return 'Transferencia';
			case 'DISCOUNT':		return '';
			case 'RETURN_DISCOUNT':	return 'RETORNO';
			case 'PAYPAL': return 'PAYPAL';
		}

		return 'OTRO';
	}

	getPaymentMethodsString(pi_array:PaymentInfo[], order_info:OrderInfo):string
	{
		if( !pi_array || pi_array.length == 0 )
		{
			return '';
		}

		// Usar Set para evitar duplicados
		let payment_methods = new Set<string>();

		// Recorrer cada pago
		for(let payment_info of pi_array)
		{
			// Recorrer los movimientos bancarios de cada pago
			for(let movement_info of payment_info.movements)
			{
				// Verificar que este movimiento está asociado con esta orden específica
				let has_this_order = movement_info.bank_movement_orders?.some(bmo => bmo.order_id == order_info.order.id);

				if( has_this_order )
				{
					// Convertir el tipo de transacción a texto en español
					let tipo_transaccion = this.getTransactionType( movement_info.bank_movement.transaction_type );

					// Solo agregar si tiene un nombre válido (no vacío)
					if( tipo_transaccion )
					{
						payment_methods.add( tipo_transaccion );
					}
				}
			}
		}

		// Convertir Set a array y unir con comas
		return Array.from(payment_methods).join(', ');
	}


	getPaymentByOrderIdMap(payment_responses:RestResponse<PaymentInfo>[]):Map<number,PaymentInfo[]>
	{
		let payment_maps =new	Map<number,PaymentInfo[]>();

		for(let pr of payment_responses )
		{
			for(let payment_info of pr.data)
			{
				let o_ids = new Map<number,number>();

				for(let bmi of payment_info.movements )
				{
					bmi.bank_movement_orders.forEach( bmo => o_ids.set( bmo.order_id, bmo.order_id) );
				}

				let order_ids = Array.from( o_ids.keys() );

				for(let id of order_ids )
				{
					if( !payment_maps.has( id ) )
					{
						payment_maps.set( id, [] );
					}

					payment_maps.get(id).push( payment_info );
				}
			}
		}
		return payment_maps;
	}


	fechaIncialChange(fecha:string)
	{
		this.fecha_inicial = fecha;
		if( fecha )
		{
			this.order_search.search_extra.start_timestamp = Utils.getDateFromLocalMysqlString(fecha);
		}
		else
		{
			this.order_search.search_extra.start_timestamp = null;
		}
	}

	fechaFinalChange(fecha:string)
	{
		this.fecha_final = fecha;
		if( fecha )
		{
			this.order_search.search_extra.end_timestamp= Utils.getDateFromLocalMysqlString(fecha);
		}
		else
		{
			this.order_search.search_extra.end_timestamp = null;
		}
	}

	confirmAddStockToStore(order_info:OrderInfo)
	{
		let store = this.store_list.find((store)=>store.id == order_info.client.store_id);
		let msg = 'Estas seguro de querer agregar el inventario la orden a una sucursal'+store.name;
		let title = 'Agregar Inventario a "'+store.name+'"';

		this.subs.sink = this.confirmation
		.showConfirmAlert
		(
			order_info,
			title,
			msg,
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.is_loading = true;
				this.subs.sink = this.rest.update
				(
					'addStockToStoreFromClientOrder',
					{ order_id: order_info.order.id }
				)
				.subscribe
				(
					()=>{
						this.is_loading = false;
						this.showSuccess('Se agrego el inventario a la sucursal')
					},
					(error)=>{ this.showError(error) }
				);
			}
		});
	}

	showSendToStore(order_info:OrderInfo)
	{
		this.selected_order_info = order_info;
		this.show_create_shipping = true;
	}

	confirmSendToStore(evt:Event)
	{
		let store = this.store_list.find((store)=>store.id == this.selected_order_info.client.store_id);
		this.is_loading = true;

		let params = {
			store_id: store.id,
			order_id: this.selected_order_info.order.id,
			date:	this.shipping_date,
			shipping_guide:	this.shipping_guide,
			shipping_company:	this.shipping_company,
		};

		this.subs.sink = this.rest.update('addShippingFromOrderToClientStore',params)
		.subscribe(()=>
		{

			this.showSuccess('El envio se creo exitosamente');
			this.is_loading = false;

			this.shipping_date = '';
			this.shipping_guide = '';
			this.shipping_company = '';
			this.show_create_shipping = false;

			let f = evt.target as HTMLFormElement;
			f.reset();
		},(error)=>this.showError(error));
	}

	markAsSentChange(evt:Event)
	{
		let i = evt.target as HTMLInputElement;
		this.mark_as_sent = i.checked;
	}

	syncOrders()
	{
		this.is_loading = true;
		let orders_to_sync = this.order_info_list
		.filter((oi:OrderInfo)=>
		{
			return oi.order.status == 'CLOSED';
		})
		.map((oi:OrderInfo)=>
		{
			return this.rest.proccessOfflineOrder(oi)
			.then(()=>
			{
				return Promise.resolve( 1 );
			})
			.catch((error)=>
			{
				console.log('No se actualizo la orden', error);
				return Promise.resolve( 0 );
			});
		});

		Promise.all( orders_to_sync )
		.then((response)=>
		{
			let sum = response.reduce((p,c)=>p+c,0);
			this.showSuccess('Se actualizaron '+sum+' Ordenes');
			return this.rest.getOfflineOrders();
		})
		.then((response)=>
		{
			this.order_info_list = response.map(oi=>this.getCustomOrderInfo(oi));
		})
		.catch((error)=>
		{
			this.showError( error );
		});
	}

	getCustomOrderInfo(order_info:OrderInfo):CustomOrderInfo
	{
		let article_discount = this.getArticleDiscount( order_info.items, order_info.order.tax_percent );

		let price_name = this.price_type_list.find(pt=>pt.id == order_info.order.price_type_id )?.name || '';
		let pdf_url = '';

		if(order_info.sat_factura)
		{
			pdf_url = order_info.sat_factura?.pdf_attachment_id
			? this.rest.getFacturaPdfUrl(order_info.order.id)
			: this.getPdfUrl(order_info.sat_factura);
		}

		return {
			...order_info,
			article_discount,
			price_name,
			selected: false,
			pdf_url

		}
	}

	getArticleDiscount(order_item_infos:OrderItemInfo[], tax_percent:number)
	{
		return order_item_infos.reduce((prev,oi)=>
		{
			//If they are equal then there isn't a discount
			if( oi.order_item.original_unitary_price >= oi.order_item.unitary_price_meta )
				return prev;

			let diff = oi.order_item.unitary_price_meta - oi.order_item.original_unitary_price;
			let tax = oi.order_item.tax == 0 ? 0 : tax_percent;

			//Tax exepmt
			if( tax == 0 )
				return prev+(oi.order_item.unitary_price_meta-oi.order_item.original_unitary_price)*oi.order_item.qty;

			let does_price_include_tax = oi.order_item.original_unitary_price > (oi.order_item.unitary_price+0.001);
			let price_with_tax = does_price_include_tax ? oi.order_item.unitary_price_meta : (oi.order_item.unitary_price_meta*( 1 + tax_percent ));
			let original_total = oi.order_item.qty* price_with_tax;

			return prev+(original_total-oi.order_item.total);
		},0);
	}

	getPdfUrl(sat_factura: Sat_Factura)
	{
		return this.rest.getApiUrl()+'/getFacturaPdf.php?sat_factura_id='+sat_factura?.id;
	}

	toggleAdvancedSearch(evt:Event)
	{
		let input = evt.target as HTMLInputElement;
		this.show_advanced_search = input.checked
	}

	resetInfo()
	{

	}

	goOffline()
	{
		this.confirmation.showConfirmAlert
		(
			{},'Activar modo offline','Estas seguro de querere activar el modo offline'
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.rest.is_offline = true;
			}
		});
	}

	goOnline()
	{
		this.confirmation.showConfirmAlert
		(
			{},'Activar modo en linea','Estas seguro de querere activar el modo en linea'
		)
		.subscribe((response)=>
		{
			if( response.accepted )
			{
				this.rest.is_offline = false;
			}
		});
	}

	syncData()
	{
		this.is_loading = true;
		this.rest.forceSyncOfflineItems()
		.then(()=>
		{
			this.showSuccess('Datos de soporte actualizados');
			this.is_loading = false;
		},(error)=>this.showError( error ));
	}

	resetCache()
	{
		this.rest.systemUpdate()
	}

	showCancelOrderModal(order_info:OrderInfo)
	{
		this.selected_order_info = order_info;
		this.show_cancel_order = true;
	}

	loadLastOrders()
	{
		let search:SearchObject<COrder> = this.getEmptySearch();
		search.eq.status = 'CLOSED';
		search.limit = 20;
		search.page = 0;
		search.sort_order = ['created_DESC'];

		this.subs.sink = this.rest.order_info
			.search( search )
			.subscribe((response)=>
			{
				this.order_info_list = response.data.map(oi=> this.getCustomOrderInfo(oi));

				//Se acota order_search a las ordenes que se acaban de mostrar
				//para que los botones de exportar saquen exactamente esas
				let last_search:SearchObject<COrder> = this.getEmptySearch();
				last_search.csv.id = response.data.map(oi=>oi.order.id);
				last_search.sort_order = ['created_DESC'];
				this.order_search = last_search;
				//if( this.order_info_list.length )
				//{
				//	let first = this.order_info_list[this.order_info_list.length-1];
				//	let last = this.order_info_list[0];

				//	this.fecha_inicial = Utils.getLocalMysqlStringFromDate(first.order.created);
				//	this.fecha_final = Utils.getLocalMysqlStringFromDate(last.order.created);
				//	this.fechaIncialChange( this.fecha_inicial );
				//	this.fechaFinalChange( this.fecha_final );
				//}
			});
	}

	cancelOrderWithMessage(evt:Event)
	{
		evt.preventDefault();

		if( this.cancellation_reason.trim() == '' )
		{
			this.showError('La razon de cancelar no puede estar vacia');
			return;
		}

		this.is_loading = true;

		this.subs.sink = this.rest
		.cancelOrder( this.selected_order_info.order.id, this.cancellation_reason )
		.subscribe
		(
			()=>
			{
				this.is_loading = false;
				this.selected_order_info.order.status = 'CANCELLED';
				this.show_cancel_order = false;
				this.cancellation_reason = '';
				this.showSuccess('La orden se cancelo exitosamente');
			},
			(error)=>{ this.showError(error); }
		);
	}

	clickOnHeader(header:string)
	{
		this.sort('total_final',this.order_search);
	}

	duplicateOrderInfo(order_info:OrderInfo)
	{
		this.subs.sink = this.rest.price_type
		.searchAll({limit:999999})
		.subscribe
		({
			next:(price_type_response)=>
			{
				let duplicated_oi = GetEmpty.orderInfo
				(
					this.rest,
					price_type_response.data,
					this.store_list
				);

				duplicated_oi.order.store_id = order_info.store.id;
				duplicated_oi.store = this.store_list.find(s=>s.id == order_info.store.id);
			},
			error:(error)=>
			{
				this.showError(error);
			}
		});
	}

	exportOrders2(evt:Event)
	{
		let search:SearchObject<Order> = {...this.order_search};
		search.limit = 100;

		this.show_export_modal = true;
		this.export_message = 'Descargando...';
		this.export_progress = 0;

		let update_lambda = (counter: number, total: number) => {
			this.export_loading_current = counter + 1;
			this.export_loading_total = total;
			this.export_progress = ((counter + 1) / total) * 100;
		};

		this.subs.sink = this.rest.order_info
		.searchAllWithProgress(search, 100, false, update_lambda)
		.subscribe((response)=>
		{
			this.show_export_modal = false;
			let cdate = Utils.getLocalMysqlStringFromDate(new Date()).substring(0,10);
			let array = response.data.map((order_info:OrderInfo)=>{
			return {
				'Id':	order_info.order.id,
				'Total':	order_info.order.total,
				'Descuento': order_info.order.discount,
				'TotalAPagar': order_info.order.total-order_info.order.discount,
				'Descuento Articulos': this.getArticleDiscount( order_info.items, order_info.order.tax_percent ),
				'Sucursal':	order_info.store.name,
				'Folio':	order_info.order.store_consecutive,
				'Fecha':	Utils.getLocalMysqlStringFromDate(order_info.order?.system_activated ? order_info.order.system_activated : order_info.order.created ).substring(0,10),
				'Estatus':	order_info.order.status,
				}
			});
			ExcelUtils.array2xlsx(array,'orders-'+cdate+'.xlsx', ['Id','Cliente','Total','Pagado','Sucursal','Folio','Facturado','Fecha','Pago','Estatus']);
		},(error)=>{
			this.show_export_modal = false;
			this.showError(error);
		});
	}
}
